// The paths under /app that belong to the platform and not to the project's app.
//
// The project routes on this page's own URL (see presentation/main/Main.js), so the two
// share one address space: everything under /app is the app's, except these. Most of them
// are modals — they open *over* whatever the app has on screen rather than replacing it.
//
// The list is handed to the app at mount so its router can leave them alone: its <Switch>
// never sees them, and the screen it was on stays behind whatever the platform opened on
// top. Without that, the app would find no route for /share, run the closing <Redirect> of
// its own <Switch>, and navigate the page out from under the modal.
//
// This is the only list: the modals take their `path` from here, so a route added there
// cannot be forgotten here.

// Modals rendered by Presentation.view over the active section.
export const HOST_MODAL_PATHS = {
  share: ["/share", "/:flowId/share"],
  editFlow: ["/edit_flow", "/:flowId/edit_flow"],
  syncFlow: "/sync_flow",
  createFolder: "/create_folder",
  editFolder: "/:folderId/edit_folder",
  website: "/flow/website/:url",
};

// Platform sections that replace the presentation instead of overlaying it (Home.view).
// They unmount the app, but they are listed all the same: on the way there the app must
// not redirect the page back to itself.
export const HOST_SECTION_PATHS = ["/settings", "/organizations"];

// Routes of the app shell (App.view), which live outside /app. The project's router pushes
// on this page's history, so its `navigate("/logout")` arrives as /app/logout: Home.view
// leaves /app for the real route with a full page load.
export const HOST_SHELL_PATHS = ["/logout", "/login"];

// Everything the platform owns, flattened — the shape the app's router expects.
export const HOST_PATHS = [
  ...Object.values(HOST_MODAL_PATHS).flat(),
  ...HOST_SECTION_PATHS,
  ...HOST_SHELL_PATHS,
];
